export default __webpack_public_path__ + "static/media/boots_of_the_doomsayer.d3e8b729.jpg";